import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { generateCompleteSEO } from '../utils/seo';

export default function NotFound() {
  const seoData = generateCompleteSEO({
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist. Browse the Visibeen Directory to find local businesses across India.',
    url: '/404',
    noindex: true,
    nofollow: true
  });

  return (
    <div style={{ padding: 24 }}>
      <SEOHead
        title={seoData.title}
        description={seoData.meta.description}
        canonical={seoData.link.canonical}
        robots={seoData.meta.robots}
        ogTitle={seoData.meta['og:title']}
        ogDescription={seoData.meta['og:description']}
        ogUrl={seoData.meta['og:url']}
        twitterTitle={seoData.meta['twitter:title']}
        twitterDescription={seoData.meta['twitter:description']}
      />

      <h1>404 - Page Not Found</h1>
      <p>The page you requested could not be found.</p>
      <p>
        Go back to the <Link to="/">homepage</Link>.
      </p>
    </div>
  );
}
